import React from 'react';
import DateFormat from 'constants/date_format';
import IndexTableBodyCell from './table/body_cell';

const lastModifiedCell = ({ lastModified }) => {
  const renderDate = () => {
    let date = moment(lastModified.date);
    date =
      date.year() !== moment().year()
        ? date.format(DateFormat.MONTH_DAY_YEAR_SHORT)
        : date.format(DateFormat.MONTH_DAY_SHORT);
    return <div>{date}</div>;
  };

  return (
    <IndexTableBodyCell
      size="l"
      name="last-modified"
      className="ContentRow-lastModified"
      hideBelowXS
    >
      {renderDate()}
      {lastModified.name && (
        <div className="Index-tableSecondaryField">
          {`${lastModified.type === 'created' ? 'Created' : 'Updated'} by ${
            lastModified.name
          }`}
        </div>
      )}
    </IndexTableBodyCell>
  );
};

export default lastModifiedCell;
